import * as env from '@/common/environment';
import { store } from '@/store';
import { httpClient } from './http-client';
import type * as ApiModel from './models.pleased';

/**
 * Log error events to the Pleased event tracking service
 */
export async function logErrorEvents(error: ApiModel.LogErrorEvent) {
  const userStore = (store.state as {
    user: { pleasedUser: { userId?: string } };
  }).user;
  const userId = userStore.pleasedUser.userId || '';

  const brandCode = env.get('brandCode');
  const url = env.get('url');
  const environment = env.get('environment');
  const eventTime = new Date().toISOString();
  const additionalData = error ? JSON.stringify(error) : '';

  const log = {
    level: 'info',
    log: `[${eventTime}] [FE-CHATBOT-LOGS] Brand code: ${brandCode}, url: ${url}, userId: ${userId} ${
      additionalData ? ' Additional details: ' + additionalData : ''
    }`,
    event_time: eventTime,
    env: environment,
  };
  await httpClient.post(
    'https://event.pls-696e7465726e616c.link/event.web', log
  );
}
